import { render } from "./SectionSolutionWelcome.vue?vue&type=template&id=441c8fde&scoped=true"
import script from "./SectionSolutionWelcome.vue?vue&type=script&lang=js"
export * from "./SectionSolutionWelcome.vue?vue&type=script&lang=js"

import "./SectionSolutionWelcome.vue?vue&type=style&index=0&id=441c8fde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441c8fde"]])

export default __exports__